import { useEffect } from "react";
import { usageTracker, UsageTrackerEvent } from "@volumental/analytic";
import { sendEvent } from "@volumental/link";
import { useExitModals } from "./exit-modal-provider/use-exit-modals";

export function StandaloneScannerAbortHandler(): null {
  const { requestExit } = useExitModals();

  useEffect(() => {
    const sp = new URLSearchParams(globalThis.location.search);
    if (sp.get("callback_state") !== "abort") return;
    usageTracker.track(UsageTrackerEvent.ScannerCallbackAbort);
    requestExit({
      onClose: () => {
        sendEvent({ type: "close", data: undefined });
      },
    });
    // Fire exactly once on mount; requestExit identity isn't a meaningful trigger.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
